
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ArrowRightInfoIcon extends Vue {
  @Prop({ default: '7' }) readonly width?: string;
  @Prop({ default: '14' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
